import { BellFilled } from '@ant-design/icons';
import { Button } from 'components/ui/button';
import useReminderState from 'hooks/useReminderState';
import { cn } from 'lib/utils';
import posthog from 'posthog-js';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SymptomTrackingReminderModal from './modals/SymptomTrackingReminderModal';

export type SymptomTrackingReminderProps = {
  mode: 'full' | 'iconOnly' | 'callToAction';
  onReminderEnabled?: () => void;
  hidePeriodReminder?: boolean;
  hideDailyReminder?: boolean;
};

const SymptomTrackingReminder: React.FC<SymptomTrackingReminderProps> = ({
  mode,
  onReminderEnabled,
  hidePeriodReminder = false,
  hideDailyReminder = false,
}) => {
  const { t } = useTranslation();
  const [showNotificationScheduleModal, setShowNotificationScheduleModal] = useState<boolean>(false);

  const { reminderTime, isPeriodReminderEnabled, areDailyNotificationsEnabled } = useReminderState();

  const showReminderModal = () => {
    setShowNotificationScheduleModal(true);
    posthog.capture('tracking.reminder_modal_opened');
  };

  const handleCloseModal = () => {
    setShowNotificationScheduleModal(false);
  };

  const getIconColorClass = () => {
    if (mode === 'callToAction') {
      return 'text-primary-foreground';
    }
    if (areDailyNotificationsEnabled || isPeriodReminderEnabled) {
      return 'text-foreground';
    }
    return 'text-muted-foreground';
  };

  return (
    <>
      <Button
        variant={mode === 'callToAction' ? 'default' : 'secondary'}
        size="lg"
        onClick={showReminderModal}
        className={cn(mode !== 'callToAction' && 'text-muted-foreground')}
      >
        {mode == 'callToAction' && t('symptomTracking.reminder.callToAction')}

        {mode == 'full' &&
          (areDailyNotificationsEnabled && reminderTime ? (
            /* Daily reminder is active : display time */
            <>
              {t('symptomTracking.reminder.active')} :{' '}
              <b>
                {reminderTime.hour.toString().padStart(2, '0')}:{reminderTime.minute.toString().padStart(2, '0')}
              </b>
            </>
          ) : (
            /* Daily reminder is inactive  */
            t('symptomTracking.reminder.inactive')
          ))}

        <BellFilled className={getIconColorClass()} />
      </Button>
      <SymptomTrackingReminderModal
        isOpen={showNotificationScheduleModal}
        onClose={handleCloseModal}
        onReminderEnabled={onReminderEnabled}
        hidePeriodReminder={hidePeriodReminder}
        hideDailyReminder={hideDailyReminder}
      />
    </>
  );
};

export default SymptomTrackingReminder;
